import { StoryblokComponent } from '@storyblok/react'
import React from 'react'


import { PropsWithClassName } from '@helper/PropsWithClassName'
import { editable } from '@helper/storyblokEditable'

import {
  PersonalizedSection,
  TextSection,
} from '@definitions/types/storyblokTypes'

import { Root } from './StoryblokPersonalizedSection.styles'

interface Props extends PropsWithClassName {
  blok: PersonalizedSection
}

const StoryblokPersonalizedSection = (props: Props) => {
  const { blok } = props
  return (
    <Root
      {...editable(blok)}
      key={blok._uid}
      data-testid="storyblok-personalized-section-root"
    >
      {blok.preview === 'new_visitor' &&
        (blok.new_visitor_blocks as TextSection[] | undefined)?.map(
          (newVisitorBlock) => (
            <StoryblokComponent
              key={newVisitorBlock._uid}
              blok={newVisitorBlock}
            />
          )
        )}
      {blok.preview === 'returning_visitor' &&
        (blok.returning_visitor_blocks as TextSection[] | undefined)?.map(
          (returningVisitorBlock) => (
            <StoryblokComponent
              key={returningVisitorBlock._uid}
              blok={returningVisitorBlock}
            />
          )
        )}
    </Root>
  )
}

export { StoryblokPersonalizedSection }
